var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNbQrcode(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34 13.148c.834 0 1.512.678 1.512 1.513v7.565c-.026.835-.704 1.513-1.539 1.513H1.748c-.809 0-1.487-.678-1.487-1.513v-7.565c0-.835.678-1.513 1.513-1.513h7.565zm14.4 7.07v3.521h-3.523v-3.522h3.522zm-7.044 0v3.521h-3.522v-3.522h3.522zm-7.618-5.296H2.035v7.043h7.043v-7.043zm-1.774 1.774v3.521H3.783v-3.521h3.521zm12.913 0v3.521h-3.521v-3.521h3.521zm-3.521-3.522v3.522h-3.522v-3.522h3.522zm7.043 0v3.522h-3.522v-3.522h3.522zM9.34.26c.835 0 1.513.678 1.513 1.513v7.565a1.55 1.55 0 01-1.539 1.487H1.748A1.514 1.514 0 01.235 9.313V1.748A1.55 1.55 0 011.774.26h7.565zM22.226.235c.835 0 1.513.678 1.513 1.513v7.565c0 .835-.678 1.513-1.513 1.513h-7.565a1.514 1.514 0 01-1.513-1.513V1.748c0-.835.678-1.513 1.513-1.513h7.565zm-13.148 1.8H2.035v7.043h7.043V2.035zm12.887 0h-7.043v7.043h7.043V2.035zM7.305 3.783v3.521H3.782V3.783h3.521zm12.912 0v3.521h-3.521V3.783h3.521z",
    fill: "#0A24EB",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbQrcode);
export default __webpack_public_path__ + "static/media/nb-qrcode.6f85dd7ab8c1ee344be43c1ed2c1c681.svg";
export { ForwardRef as ReactComponent };